import home_zastupko from "../zastupko/home";

/**
 * Definition of Home page
 * 
 * @author Jiri Hynek
 */
const home = home_zastupko;
export default home;